import { useEffect } from 'react';
import PageHeader from '@/components/base/PageHeader';

export default function Impressum() {
  useEffect(() => {
    document.title = 'Impressum | Druckerei Rahmede';
  }, []);

  return (
    <>
      <PageHeader
        label="Rechtliches"
        title="Impressum"
      />

      <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto">
          <div className="space-y-10">
            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Angaben gemäß § 5 TMG
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-1">
                <p className="font-semibold text-foreground-800">Rahmede GmbH</p>
                <p>Unterm Eichholz 8</p>
                <p>58579 Schalksmühle-Heedfeld</p>
                <p>Deutschland</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Vertretung
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Die Rahmede GmbH wird vertreten durch die Geschäftsführung.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Kontakt
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-1">
                <p>Telefon: 02351 4327721</p>
                <p>E-Mail: info@rahmede-druck.de</p>
              </div>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Registereintrag
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Eintragung im Handelsregister.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Umsatzsteuer-ID
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Verbraucherstreitbeilegung / Universalschlichtungsstelle
              </h2>
              <p className="text-sm text-foreground-600 leading-relaxed">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </div>

            <div>
              <h2 className="font-heading text-xl font-bold text-foreground-900 mb-4">
                Haftungsausschluss
              </h2>
              <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                <p>
                  <strong className="text-foreground-800">Haftung für Inhalte</strong><br />
                  Die Inhalte unserer Seiten wurden mit größter Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität der Inhalte können wir jedoch keine Gewähr übernehmen. Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich.
                </p>
                <p>
                  <strong className="text-foreground-800">Haftung für Links</strong><br />
                  Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
                </p>
                <p>
                  <strong className="text-foreground-800">Urheberrecht</strong><br />
                  Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}